import { DoelId } from 'parkour-web-app-dto';

export function validateDoelId(id: string | null): DoelId {
  if (id === null) {
    throw Error('Id cannot be null');
  }

  return id as DoelId;
}
